import { render, staticRenderFns } from "./LogProcessControls.vue?vue&type=template&id=1ab12b28&scoped=true&lang=html&"
import script from "./LogProcessControls.vue?vue&type=script&lang=js&"
export * from "./LogProcessControls.vue?vue&type=script&lang=js&"
import style0 from "./LogProcessControls.vue?vue&type=style&index=0&id=1ab12b28&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab12b28",
  null
  
)

export default component.exports